var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.569 2.17879L6.17411 11.5748C6.05935 11.6896 6.00136 11.843 6.00015 11.9989C5.99653 12.1619 6.05693 12.313 6.17411 12.4313L15.569 21.8262C15.8009 22.0581 16.1911 22.0593 16.4279 21.8214L17.2747 20.9782C17.5223 20.7281 17.5139 20.3536 17.2771 20.1192L9.16278 12.0025L17.2771 3.88815C17.5091 3.65621 17.5115 3.26722 17.2747 3.02924L16.4279 2.18483C16.3034 2.05919 16.15 2 15.9966 2C15.8408 2 15.6873 2.0604 15.569 2.17879Z","fill":"currentColor"}));
}

Back.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Back;

Back.default = Back;
